(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/views/bankcard-payment.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/views/bankcard-payment.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  const formatCurrency = svs.utils.format.Currency;
  const formatTime = svs.utils.date.FormatTime;
  const capitalize = svs.utils.format.capitalize;
  svs.tur.start_subscription.views.BankcardPayment = Marionette.View.extend({
    ui: {
      payWithCardBtn: '.js-pay-with-card-button'
    },
    events: {
      'click @ui.payWithCardBtn': 'payWithCardBtnClicked'
    },
    regions: {
      bankcardPaymentRegion: '#bankcardPaymentRegion'
    },
    template() {
      return '<div id="bankcardPaymentRegion"></div>';
    },
    onRender() {
      this.showChildView('bankcardPaymentRegion', {
        _self: this,
        model: this.model,
        template(data) {
          return svs.tur.start_subscription.templates.bankcard_payment(data);
        },
        templateContext() {
          const result = svs.components.Storage.browser.get('templateObject', 'start_subscription');
          if (result && result.newSubId === svs.tur.start_subscription.utils.getUrlParam('swpsubid') && !this.model.attributes) {
            return result;
          }
          if (!this.model.attributes) {
            return {
              error: true
            };
          }
          if (this.model.get('isActivating')) {
            return {
              isBankcard: this.model.get('isBankcard'),
              amount: formatCurrency(this.model.get('amount')),
              weeklyCost: formatCurrency(this.model.get('weeklyBetAmount')),
              startTime: formatTime('d MMM', this.model.get('startTime')).replace('.', ''),
              stopTime: formatTime('d MMM', this.model.get('stopTime')).replace('.', ''),
              gameResultDate: capitalize(formatTime('EEEE d MMM', this.model.get('startTime')).replace('.', '')),
              lottoRuleChangePrice: svs.utils.format.Currency(this.model.get('subscriptionOptions').lottoRuleChangePrice),
              lottoRuleChangeDate: this.model.get('subscriptionOptions').lottoRuleChangeDate
            };
          }
          return {
            dayCost: formatCurrency(parseInt(this.model.get('subscriptionEntry').wagers[0].wagerAmount, 10)),
            isBankcard: this.model.get('isBankcard'),
            amount: formatCurrency(this.model.get('entry').amount),
            weeklyCost: formatCurrency(this.model.get('subscriptionOptions').weeklyCost),
            startTime: formatTime('d MMM', this.model.get('entry').startTime).replace('.', ''),
            stopTime: formatTime('d MMM', this.model.get('entry').stopTime).replace('.', ''),
            gameDaysStart: parseInt(this.model.get('entry').amount, 10) / parseInt(this.model.get('subscriptionEntry').wagers[0].wagerAmount, 10),
            gameResultDate: capitalize(formatTime('EEEE d MMM', this.model.get('startTime')).replace('.', '')),
            lottoRuleChangePrice: svs.utils.format.Currency(this.model.get('subscriptionOptions').lottoRuleChangePrice),
            lottoRuleChangeDate: this.model.get('subscriptionOptions').lottoRuleChangeDate
          };
        },
        onAttach() {
          var _svs$components, _svs$components2;
          svs === null || svs === void 0 || (_svs$components = svs.components) === null || _svs$components === void 0 || (_svs$components = _svs$components.Modal) === null || _svs$components === void 0 || (_svs$components = _svs$components.currentView()) === null || _svs$components === void 0 || _svs$components.trigger('modalContentResize');
          if (!this.options._self.options.model.isComingBack) {
            this.options._self.paymentTypeChosen(this.options._self.options.model, this.options._self.options.context);
          }
          svs === null || svs === void 0 || (_svs$components2 = svs.components) === null || _svs$components2 === void 0 || (_svs$components2 = _svs$components2.Modal) === null || _svs$components2 === void 0 || (_svs$components2 = _svs$components2.currentView()) === null || _svs$components2 === void 0 || _svs$components2.trigger('modalContentResize');
        },
        onRender() {
          var _svs$components3;
          svs.components.Modal.setHeaderOptions({
            title: 'Betala',
            doubleWidth: true,
            rightButton: {
              visible: false
            },
            leftButton: {
              text: 'Avbryt',
              visible: true,
              callback: () => {
                var _options$model, _options$model$get, _options$model2, _options$model3, _options$model3$get;
                svs.components.Storage.browser.remove('templateObject', 'start_subscription');

                const options = this.options._self.options;
                const subscriptionId = ((_options$model = options.model) === null || _options$model === void 0 || (_options$model$get = _options$model.get) === null || _options$model$get === void 0 ? void 0 : _options$model$get.call(_options$model, 'newSubId')) || ((_options$model2 = options.model) === null || _options$model2 === void 0 ? void 0 : _options$model2.subId);
                let cancelUrl = ((_options$model3 = options.model) === null || _options$model3 === void 0 || (_options$model3$get = _options$model3.get) === null || _options$model3$get === void 0 ? void 0 : _options$model3$get.call(_options$model3, 'cancelUrl')) || svs.utils.paramHandler.get({
                  key: 'cancelUrl'
                }).value;
                cancelUrl = cancelUrl ? svs.utils.url.makeInternal(cancelUrl, svs.core.urlMapping.get('myGamingsSubscriptions')) : null;
                const isHideLoader = !cancelUrl; 
                subscriptionId && svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, this, () => {}, isHideLoader);

                const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', options.context);
                if (typeof (swpCheckout === null || swpCheckout === void 0 ? void 0 : swpCheckout.cleanUpSwedbankPayTransaction) === 'function') {
                  var _this$model, _this$model$set;
                  options.context.triggerPrefixMethod('cancelButtonFirstPayBankcardSubscription');
                  (_this$model = this.model) === null || _this$model === void 0 || (_this$model$set = _this$model.set) === null || _this$model$set === void 0 || _this$model$set.call(_this$model, 'paymentCancelled', true);
                  swpCheckout.cleanUpSwedbankPayTransaction();
                } else {
                  options.context.triggerPrefixMethod('cancelButtonBeforeFirstPayBankcardSubscription');
                }

                svs.components.Modal.hide();
                if (cancelUrl) {
                  svs.components.loader.show();
                  svs.utils.url.navigate(decodeURIComponent(cancelUrl));
                }
              }
            }
          });
          svs === null || svs === void 0 || (_svs$components3 = svs.components) === null || _svs$components3 === void 0 || (_svs$components3 = _svs$components3.Modal) === null || _svs$components3 === void 0 || (_svs$components3 = _svs$components3.currentView()) === null || _svs$components3 === void 0 || _svs$components3.trigger('modalContentResize');
        }
      });
    },
    paymentTypeChosen(model, context) {
      const isActivating = model && model.get('isActivating') || false;
      const success = () => {
        var _context$view;
        const subId = model.get('newSubId') || model.get('subscriptionId'); 
        svs.tur.start_subscription.utils.updateQuerystringWithParamAndValue('swpsubid', subId);
        if (isActivating) {
          svs.tur.start_subscription.utils.updateQuerystringWithParamAndValue('act', isActivating);
        }
        const makeSwedbankPayCardPaymentCallback = () => {
          svs.tur.start_subscription.radio.request('makeSwedbankPayCardPayment', subId, model.get('amount'), location.href, context ? context : this, isActivating);
        };
        if (typeof (context === null || context === void 0 || (_context$view = context.view) === null || _context$view === void 0 ? void 0 : _context$view.triggerMethod) === 'function') {
          if (isActivating) {
            context.view.triggerMethod('saveTrackingFromSubscription', context, () => {
              makeSwedbankPayCardPaymentCallback();
            });
          } else {
            context.view.triggerMethod('saveTrackingFromWager', context, () => {
              makeSwedbankPayCardPaymentCallback();
            });
          }
        } else {
          makeSwedbankPayCardPaymentCallback();
        }
      };
      model.postNewSubscription({
        context: context ? context : this,
        success
      });
    }
  });
})(Backbone, _, svs);

 })(window);